// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b77292a4","477":"822994ea"}[chunkId] + ".chunk.js";
};